export enum AutoBackupSchedule {
        Hourly = '0 * * * *', // every hour
        Daily ='0 0 * * *', // every day
        Weekly = '0 0 * * 5' //on friday of every month
   
}